"use client";

import { NormalText } from "@/components/text/NormalText";
import { SmallTitle } from "@/components/text/SmallTitle";
import { IsolationConstructedNoDates } from "@/types/types";
import { formatDateForOutput } from "@/utils/formatTime/formatDateForOutput";
import { useIsClient } from "@/utils/hooks/useIsClient";

export function Details({
  isolation,
}: {
  isolation: IsolationConstructedNoDates;
}) {
  const isClient = useIsClient();

  return (
    <div className="mt-2">
      <div className="flex justify-between gap-x-6">
        <SmallTitle elementType="span" className="whitespace-nowrap text-xs">
          Created:
        </SmallTitle>
        <NormalText elementType="span" className="break-all text-xs">
          {isClient &&
            formatDateForOutput({
              date: new Date(isolation.createdAtString),
              withTime: true,
              withYear: false,
            })}
        </NormalText>
      </div>

      <div className="mt-2 flex justify-between gap-x-6">
        <SmallTitle elementType="span" className="whitespace-nowrap text-xs">
          Original file:
        </SmallTitle>
        <NormalText elementType="span" className="break-all text-xs">
          {isolation.name}
        </NormalText>
      </div>

      <div className="mt-2 flex justify-between gap-x-6">
        <SmallTitle elementType="span" className="whitespace-nowrap text-xs">
          Remove instrumental:
        </SmallTitle>
        <NormalText elementType="span" className="break-all text-xs">
          {isolation.removeInstrumental ? "Yes" : "No"}
        </NormalText>
      </div>

      <div className="mt-2 flex justify-between gap-x-6">
        <SmallTitle elementType="span" className="whitespace-nowrap text-xs">
          Remove background vocals:
        </SmallTitle>
        <NormalText elementType="span" className="break-all text-xs">
          {isolation.removeBackgroundVocals ? "Yes" : "No"}
        </NormalText>
      </div>

      <div className="mt-2 flex justify-between gap-x-6">
        <SmallTitle elementType="span" className="whitespace-nowrap text-xs">
          Remove reverb and echo:
        </SmallTitle>
        <NormalText elementType="span" className="break-all text-xs">
          {isolation.deReverbDeEcho ? "Yes" : "No"}
        </NormalText>
      </div>

      <div className="mt-2 flex justify-between gap-x-6">
        <SmallTitle elementType="span" className="whitespace-nowrap text-xs">
          Remove noise:
        </SmallTitle>
        <NormalText elementType="span" className="break-all text-xs">
          {isolation.deNoise ? "Yes" : "No"}
        </NormalText>
      </div>
    </div>
  );
}
